module.exports = __webpack_public_path__ + "static/img/tongyong.48706fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/tongyong.png
// module id = 581I
// module chunks = 18